<script setup lang="ts">
import { onBeforeMount, ref, Ref } from "vue";
import { useApiClient } from "@/api/client";
import ModuleLoading from "@/ui/components/loading/moduleLoading.vue";
import { toastApiResult } from "@/toaster";
import { loadingWrapper } from "@/api/helpers/loadingWrapper";
import NotificationSettingsManager from "@/modules/users/components/NotificationSettingsManager.vue";
import { useBaseStore } from "@/stores/base";

const availableNotificationTypes: Ref<App.Data.NotificationTypeDO[]> = ref();

const loadAvailableNotifications = async () => {
	const response = await loadingWrapper(
		useApiClient("notifications").getAvailableNotificationTypes()
	);

	if (response.isOk()) {
		availableNotificationTypes.value = response.value;
	}
};

onBeforeMount(() => {
	loadAvailableNotifications();
});

const updateNotificationSettings = () => {
	return async (updateNotificationDTO: App.Data.UpdateNotificationDTO) => {
		await toastApiResult(
			useApiClient("users").updateNotificationTypeChannelFromProfile(
				updateNotificationDTO
			)
		);
	};
};
</script>

<template>
	<module-loading>
		<notification-settings-manager
			:async-update-function="updateNotificationSettings()"
			:configured-notification-types="
				useBaseStore().currentUser.notificationTypes
			"
			:available-notification-types="availableNotificationTypes"
		>
		</notification-settings-manager>
	</module-loading>
</template>

<style lang="scss">
.v-expansion-panel-title__overlay {
	background: rgba(var(--v-theme-primary)) !important;
}
</style>
